import React from "react";
import '../print.css';
import moment from "moment";

export default class ComponentToPrint extends React.Component {
  renderqr(data) {
    const total = this.props.total;
    let qrdata = (data == undefined || data == null || data.length === 0) ? null : (
      data.map((d, index) => {
        return (
          <div key={index} className="record-container" style={{ position: 'relative' }}>
            <div className="table-responsive row-top-gap">
              <div className="header">
                <div style={{ position: 'absolute', top: 0, right: 0, fontSize: '20px', fontWeight: 'bold' }}>INVOICE</div>
                <div style={{ position: 'absolute', top: 0, left: 0, fontSize: '20px', fontWeight: 'bold' }}>TC 19</div>
              </div>
              <br />
              <div style={{ textAlign: 'center', width: '100%' }}>
                <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold', marginTop: '20px', width: '100%' }}>Finlay Teas (Pvt) Ltd</div>
                <div style={{ textAlign: 'center', fontSize: '16px', width: '100%' }}>P. O Box 01, Haldummulla</div>
                <div style={{ textAlign: 'center', fontSize: '16px', width: '100%' }}>057 2268326 Email - fingreen.lka@finlays.net</div>
              </div>
              <br />
              <div style={{ textAlign: 'center', width: '100%' }}>
                <div style={{ textAlign: "left", fontSize: "12px" }} colSpan="5" width="50%" height="70"><b>For the month of :</b> {d.month}</div>
                <div style={{ textAlign: "left", fontSize: "12px" }} colSpan="5" width="50%" height="70"><b>Supplier No :</b> {d.registrationNumber}</div>
                <div style={{ textAlign: "left", fontSize: "12px" }} colSpan="5" width="50%" height="70"><b>Supplier Name :</b> {d.firstName}</div>
              </div>
              <div style={{ textAlign: 'center', width: '100%' }}>
                <table style={{ borderCollapse: 'collapse', width: '100%', border: '1px solid black' }}>
                  <thead>
                    <tr>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold' }}>Date</th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold' }}>Qty/Normal</th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold' }}>Qty/Super</th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold' }}>Date</th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold' }}>Qty/Normal</th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold' }}>Qty/Super</th>
                    </tr>
                  </thead>
                  <tbody>
                    {d.leafDetails.reduce((rows, transaction, transactionIndex) => {
                      if (transactionIndex % 2 === 0) {
                        rows.push([
                          <td key={transactionIndex * 2} style={{ border: '1px solid black', padding: '8px', fontSize: '12px' }}>
                            {moment(transaction.leafCollectedDate).format("YYYY-MM-DD")}
                          </td>,
                          <td key={transactionIndex * 2 + 1} style={{ border: '1px solid black', borderRight: '1px solid black', padding: '8px', fontSize: '12px', textAlign: "right" }}>
                            {transaction.normalLeafAmount.toFixed(2)}
                          </td>,
                          <td key={transactionIndex * 2 + 1} style={{ border: '1px solid black', borderRight: '1px solid black', padding: '8px', fontSize: '12px', textAlign: "right" }}>
                            {transaction.superLeafAmount.toFixed(2)}
                          </td>,
                        ]);
                      } else {
                        rows[rows.length - 1].push(
                          <td key={transactionIndex * 2} style={{ border: '1px solid black', padding: '8px', fontSize: '12px' }}>
                            {moment(transaction.leafCollectedDate).format("YYYY-MM-DD")}
                          </td>,
                          <td key={transactionIndex * 2 + 1} style={{ border: '1px solid black', borderRight: '1px solid black', padding: '8px', fontSize: '12px', textAlign: "right" }}>
                            {transaction.normalLeafAmount.toFixed(2)}
                          </td>,
                          <td key={transactionIndex * 2 + 1} style={{ border: '1px solid black', borderRight: '1px solid black', padding: '8px', fontSize: '12px', textAlign: "right" }}>
                            {transaction.superLeafAmount.toFixed(2)}
                          </td>,
                        );
                      }
                      if (d.leafDetails.length === 1 && transactionIndex % 2 === 0) {
                        rows[rows.length - 1].push(
                          <td key="emptyCell" style={{ border: '1px solid black', borderRight: '1px solid black', padding: '8px', fontSize: '12px' }}></td>
                        );
                      }

                      return rows;
                    }, []).map((row, rowIndex) => <tr key={rowIndex}>{row}</tr>)}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold' }}></td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold' }}></td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold' }}></td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold' }}></td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold', textAlign: "right" }}>
                        {d.totalNormalLeafAmount.toFixed(2)}
                      </td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '12px', fontWeight: 'bold', textAlign: "right" }}>
                        {d.totalSuperLeafAmount.toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div style={{ textAlign: 'center', width: '100%' }}>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr>
                      <th style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold' }}></th>
                      <th style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', textAlign: "right" }}>Qty</th>
                      <th style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', textAlign: "right" }}>Rs.</th>
                      <th style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', textAlign: "right" }}>Value(Rs)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', lineHeight: '0.3' }}>Total Normal leaf Qty for the month</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{d.totalNormalLeafAmount.toFixed(2)}</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{d.normalLeafRate.toFixed(2)}</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{(d.totalNormalLeafAmount * d.normalLeafRate).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', lineHeight: '0.3' }}>Total Super leaf Qty for the month</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{d.totalSuperLeafAmount.toFixed(2)}</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{d.superLeafRate.toFixed(2)}</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{(d.totalSuperLeafAmount * d.superLeafRate).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', lineHeight: '0.3' }}>Transport</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{(d.totalNormalLeafAmount + d.totalSuperLeafAmount).toFixed(2)}</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{d.transportRate.toFixed(2)}</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{((d.totalNormalLeafAmount + d.totalSuperLeafAmount) * d.transportRate).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', lineHeight: '0.3' }}>ExPay</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{(d.totalNormalLeafAmount + d.totalSuperLeafAmount).toFixed(2)}</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{d.exPayRate.toFixed(2)}</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{((d.totalNormalLeafAmount + d.totalSuperLeafAmount) * d.exPayRate).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', lineHeight: '0.3' }}>Advance</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}></td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}></td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{d.totalAdvanceAmount.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', lineHeight: '0.3' }}>Loan</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}></td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}></td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{d.totalLoanAmount.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', lineHeight: '0.3' }}>Addition</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}></td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}></td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{d.totalAddition.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', fontSize: '12px', fontWeight: 'bold', lineHeight: '0.3' }}>Deduction</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}></td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}></td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}>{d.totalDeduction.toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '8px', fontSize: '14px', fontWeight: 'bold', lineHeight: '0.3' }}>Balance</td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}></td>
                      <td style={{ padding: '8px', fontSize: '12px', textAlign: "right", lineHeight: '0.3' }}></td>
                      <td style={{ padding: '8px', fontSize: '14px', textAlign: "right", lineHeight: '0.3' }}><b>{((d.totalNormalLeafAmount * d.normalLeafRate) + (d.totalSuperLeafAmount * d.superLeafRate) - ((d.totalNormalLeafAmount + d.totalSuperLeafAmount) * d.transportRate) - ((d.totalNormalLeafAmount + d.totalSuperLeafAmount) * d.exPayRate) - (d.totalAdvanceAmount) - (d.totalLoanAmount) + (d.totalAddition) - (d.totalDeduction)).toFixed(2)}</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ textAlign: 'left', width: '30%', position: 'absolute', bottom: 0, left: 0 }}>
                <div style={{ textAlign: "center", fontSize: "12px" }} ><b>..............................</b></div>
                <div style={{ textAlign: "center", fontSize: "12px" }} ><b>Signature</b></div>
                <div style={{ textAlign: "center", fontSize: "12px" }} ><b>(Manager Finlay Teas)</b></div>
              </div>
            </div>
          </div>
        )
      })
    );

    return (
      <div>
        {qrdata}
      </div>
    );
  }


  render() {
    const renderqr = this.renderqr(this.props.supplierData);
    return (
      <table>
        <tbody>
          {renderqr}
        </tbody>
      </table>
    );
  };
}


















